const numeric = {
  mounted: function (el) {
    el.addEventListener('wheel', function (event) {
      if (el.type === 'number') {
        event.preventDefault();
      }
    });
  }
}

export default numeric
